<template>
  <v-subheader>{{ $t('labels.system') }}</v-subheader>
</template>

<script>
export default {
  name: 'SettingsHeader'
}
</script>
